import { intervalToDuration } from 'date-fns';
import { DateString } from '../types';

export namespace DateHelpers {
  export function getDaysBetweenDates(startDate: DateString, endDate: DateString): number {
    return (
      intervalToDuration({
        start: new Date(startDate),
        end: new Date(endDate),
      }).days ?? 0
    );
  }
}
